export const image = (images?: string[]) => (images?.length ? images[0] : '')
